import { render, staticRenderFns } from "./NetworkSpeed.vue?vue&type=template&id=2455ea7a&scoped=true"
import script from "./NetworkSpeed.vue?vue&type=script&lang=js"
export * from "./NetworkSpeed.vue?vue&type=script&lang=js"
import style0 from "./NetworkSpeed.vue?vue&type=style&index=0&id=2455ea7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2455ea7a",
  null
  
)

export default component.exports